import { REGEX_SPECIAL_CHARS, REGEX_WHOLE_MATCH } from 'config'

// https://stackoverflow.com/questions/1144783/how-do-i-replace-all-occurrences-of-a-string-in-javascript
const escapeRegExp = (string) =>
  string.replace(REGEX_SPECIAL_CHARS, REGEX_WHOLE_MATCH)

export const replaceAll = (str, find, replace) =>
  str.replace(new RegExp(escapeRegExp(find), 'g'), replace)
